/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DsaiIngestionSource {
    UPLOAD = 'upload',
    LIBRARY = 'library',
}
